var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#DBE3E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99976 12C4.99976 12.8556 5.69978 13.5556 6.55537 13.5556C7.41095 13.5556 8.11098 12.8556 8.11098 12C8.11098 11.1444 7.41095 10.4444 6.55537 10.4444C5.69978 10.4444 4.99976 11.1444 4.99976 12ZM15.889 12C15.889 12.8556 16.589 13.5556 17.4446 13.5556C18.3002 13.5556 19.0002 12.8556 19.0002 12C19.0002 11.1444 18.3002 10.4444 17.4446 10.4444C16.589 10.4444 15.889 11.1444 15.889 12ZM10.4444 12C10.4444 12.8556 11.1444 13.5556 12 13.5556C12.8556 13.5556 13.5556 12.8556 13.5556 12C13.5556 11.1444 12.8556 10.4444 12 10.4444C11.1444 10.4444 10.4444 11.1444 10.4444 12Z",
    fill: "#969BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/ThreeDots.c8c400091818f248491cb108ad2af68c.svg";
export { ForwardRef as ReactComponent };